import { render } from "./downloadButton.vue?vue&type=template&id=1e6b3130&scoped=true"
import script from "./downloadButton.vue?vue&type=script&lang=js"
export * from "./downloadButton.vue?vue&type=script&lang=js"

import "./downloadButton.vue?vue&type=style&index=0&id=1e6b3130&lang=scss&scoped=scoped"

import exportComponent from "E:\\giteeWorkShowma\\hardware-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e6b3130"]])

export default __exports__